import { useFactors } from "../state/FactorsContext";
import ScenarioToggle from "./ScenarioToggle";

/**
 * Full-width controls shown at the top and bottom of the journey: snap all
 * sliders to a worldview, plus a reset to the best-known consensus.
 */
export default function GlobalControls() {
  const { reset, activeScenario } = useFactors();

  return (
    <div className="flex flex-col items-center gap-3">
      <p className="text-[11px] uppercase tracking-[0.2em] text-white/55">
        Set every filter at once
      </p>
      <ScenarioToggle />
      <button
        type="button"
        onClick={reset}
        className="text-xs text-white/60 underline-offset-4 transition-colors hover:text-white/90 hover:underline"
      >
        {activeScenario === "consensus"
          ? "Reset to consensus"
          : "↺ Reset to the consensus (best-known) numbers"}
      </button>
    </div>
  );
}
